import { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AppRouter from "./app/routes/AppRouter";

function App() {
  const { i18n } = useTranslation();

  useEffect(() => {
    const language = i18n.resolvedLanguage || i18n.language || "en";
    document.documentElement.lang = language;
    document.documentElement.dir = i18n.dir(language);

    try {
      window.localStorage.setItem("appLanguage", language);
    } catch (error) {
      // Ignore storage errors in restricted environments.
    }
  }, [i18n, i18n.language, i18n.resolvedLanguage]);

  return (
    <BrowserRouter
      future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
    >
      <AppRouter />
    </BrowserRouter>
  );
}

export default App;
